// extracted by mini-css-extract-plugin
module.exports = {"mypage":"LoadFavorite_mypage__3cV9y"};